'use client';
import Typography from '@/components/shared/typography/typography.component';
import { AddressSrc, ILocation } from '@/types';
import Image from 'next/image';
import styles from './styles.module.scss';
import SylndrWorkingHoursLocation from './sylndr-hub-workings-hours-location-container/sylndr-hub-workings-hours-location-container.component';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import { X } from '../../../../public/Images';
import { useCallback, useEffect, useRef } from 'react';
import { useReverseGeocodeQuery } from '@/hook/geocoder-api-slice';
import colors from '@/theme/colors.module.scss';
import { useTranslation } from 'react-i18next';
import { NEXT_APP_SYLNDR_GOOGLE_MAP_API_KEY } from '@/constants';

const SylndrHubLocation = ({ closeModal }: { closeModal: Function }) => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: NEXT_APP_SYLNDR_GOOGLE_MAP_API_KEY,
    });

    const { t } = useTranslation();
    const defaultLoc: ILocation = {
        city: 'cairo',
        address: 'sylndr', //29.9691654,31.3219602,13z
        coordinate: { lat: 29.969183131024852, lng: 31.363160703973296 }, // 29.969183131024852, 31.363160703973296
    };

    return (
        <section className={styles.container}>
            <div className={styles.content_container}>
                <div className={styles.header_container}>
                    <Typography color={colors.gray700} variant="subtitle1">
                        {t('SylndrHubLocation')}
                    </Typography>
                    <Image
                        src={X.src}
                        width={X.width}
                        height={X.height}
                        onClick={() => closeModal()}
                        style={{ cursor: 'pointer' }}
                        alt="close"
                    />
                </div>
                <div className={styles.map_container}>
                    {isLoaded && window?.google && (
                        <Map
                            location={defaultLoc}
                            addressSrc="reverseGeolocation"
                        />
                    )}
                </div>
                <div className={styles.direction_container}>
                    <Typography>{t('inspectionDetails')}</Typography>
                    <SylndrWorkingHoursLocation showGetDirections={true} />
                </div>
            </div>
            <button
                onClick={() => closeModal()}
                style={{ height: '48px' }}
                className="sylndr_button primary"
            >
                {t('OkGotIt')}
            </button>
        </section>
    );
};
export default SylndrHubLocation;

const Map = ({
    location,
    addressSrc,
}: {
    location: ILocation;
    addressSrc: AddressSrc;
}) => {
    const defaultMapOptions: google.maps.MapOptions = {
        fullscreenControl: false,
        mapTypeControl: false,
        minZoom: 10,
        maxZoom: 20,
        streetViewControl: false,
        gestureHandling: 'greedy',
        zoomControl: false,

        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
        },
    };

    const refMap = useRef<google.maps.Map | null>(null);

    const { data, isLoading, isSuccess } = useReverseGeocodeQuery(
        {
            latLng: location.coordinate || { lat: 30.0444, lng: 31.2357 },
            lang: 'ar',
        },
        { skip: addressSrc === 'autocomplete' }
    );
    useEffect(() => {
        if (!isLoading && data && isSuccess && refMap?.current) {
            // const currCenter = refMap.current.getCenter()?.toJSON();
            // onSetLocation({
            //   coordinate: currCenter || location.coordinate,
            //   address: data?.formatted_address,
            //   city: data.address_components?.filter(
            //     (item) =>
            //       item?.types?.includes('locality') ||
            //       item?.types?.includes('administrative_area_level_2') ||
            //       item?.types?.includes('administrative_area_level_1'),
            //   )[0]?.short_name,
            // });
        }
    }, [data]);

    // const getCurrentLocation = () => {
    //     // setAddressSrc('reverseGeolocation');
    //     navigator.geolocation.getCurrentPosition(position => {
    //         const { longitude, latitude } = position.coords;
    //         if (refMap.current) {
    //             refMap.current.panTo({ lng: longitude, lat: latitude });
    //             refMap.current.setZoom(16);
    //         }
    //     });
    // };
    useEffect(() => {
        if (refMap?.current) {
            const currCenter = refMap.current.getCenter()?.toJSON();
            if (
                currCenter?.lat !== location.coordinate.lat ||
                currCenter.lng !== location.coordinate.lng
            ) {
                refMap.current.setZoom(16);
                refMap.current.panTo(location.coordinate);
            }
        }
    }, [location.coordinate, refMap?.current]);

    // const handleCenterChanged = () => {
    //     if (!refMap.current) return;
    //     const newPos = refMap.current.getCenter()?.toJSON();
    //     if (newPos) {
    //         setCurrCoords(newPos);
    //     }
    // };

    const handleLoad = useCallback((map: google.maps.Map) => {
        refMap.current = map;
        refMap.current.setCenter(location.coordinate);
        // refMap.current.addListener('idle', handleCenterChanged);
        // refMap.current.addListener('dragend', () => {
        // setAddressSrc('reverseGeolocation');
        // });
        refMap.current.setZoom(location.address ? 16 : 13);
    }, []);
    const latLng = {
        lat: location.coordinate.lat,
        lng: location.coordinate.lng,
    };
    // new google.maps.Marker({
    //   position: latLng,
    //   map,
    // });
    return (
        <>
            {/* @ts-ignore */}
            <GoogleMap
                mapContainerStyle={{
                    height: '100%',
                    width: '100%',
                    borderRadius: '8px',
                    border: '2px solid',
                    borderColor: colors.gray200,
                }}
                options={defaultMapOptions}
                mapContainerClassName="map-container"
                onLoad={handleLoad}
            >
                <div
                    style={{
                        width: '100%',
                        padding: '16px',
                    }}
                ></div>
                <div
                    style={{
                        position: 'absolute',
                        left: 'calc(50% - 13.5px)',
                        top: 'calc(50% - 49px)',
                    }}
                >
                    <MarkerF position={latLng} title={'sylndr'} />
                    {/* <Image src={MarkerPin.src} width={27} height={27} alt="marker" /> */}
                </div>
                <div
                    style={{
                        position: 'absolute',
                        bottom: '16px',
                        right: '16px',
                    }}
                >
                    {/* <Image
            src={GeoLocationButton.src}
            width={GeoLocationButton.width}
            height={GeoLocationButton.height}
            onClick={getCurrentLocation}
            alt="geo location button"
          /> */}
                </div>
            </GoogleMap>
        </>
    );
};
